import './Button.scss';
import { FC, ReactNode, CSSProperties } from 'react';
import {Link} from "react-router-dom";


interface IButton {
    type?: 'link' | 'button' | "htmlLink";
    name: ReactNode;
    className?: string;
    onClick?: (e: any) => void;
    href?: string;
    effect?: "bubble" | "";
    disabled?: boolean;
    color?: string;
    buttonStyle?: "primary"
}

const Button: FC<IButton> = ({
                                 effect = 'bubble',
                                 type = "link",
                                 name,
                                 className = '',
                                 onClick,
                                 disabled = false,
                                 href = '/',
                                 color,
                                 buttonStyle = "primary"
                             }) => {


    // Передаем цвет через CSS-переменную
    const dynamicStyle = { '--btn-bg': color } as CSSProperties;

    const handleClick = (e: any) => {
        if (disabled) {
            e.preventDefault();
            return;
        }
        if (onClick) {
            onClick(e);
        }
    };

    const commonProps = {
        onClick: handleClick,
        className: `button ${className} ${buttonStyle ? `button--${buttonStyle}` : "" } ${disabled ? 'disabled' : ''}`,
        style: dynamicStyle
    };

    const content = (
        <>
            <span className="button__name">{name}</span>
            {effect && <span className="button__effect"></span>}
        </>
    );

    if (type === 'htmlLink') {
        return (
            <a {...commonProps} target="_blank" href={disabled ? '/' : href} aria-disabled={disabled}>
                {content}
            </a>
        );
    }

    if (type === 'button') {
        return (
            <button {...commonProps} type="submit" disabled={disabled}>
                {content}
            </button>
        );
    }

    return (
        <Link {...commonProps} to={disabled ? '/' : href} aria-disabled={disabled}>
            {content}
        </Link>
    );
};

export default Button;